{
  "add_extra_cabin": "Weitere Kabine hinzufügen",
  "apply": "Anwenden",
  "availability": "Verfügbarkeit",
  "available_for_single_use": "Diese Kabine ist als Einzelkabine buchbar.",
  "button_title": {
    "add_person": "Person zu Kabine hinzufügen",
    "close_departure": "Abfahrten einklappen",
    "open_departure": "Abfahrten ausklappen",
    "remove_person": "Person aus Kabine entfernen"
  },
  "cabin_x": "Kabine {{ count }} ",
  "clear": "Löschen",
  "clear_filter": "Filter löschen",
  "close": "Schließen",
  "date": "Datum",
  "departure": "Abfahrt",
  "departure_statuses": {
    "available": "Verfügbar",
    "fully_booked": "Ausgebucht",
    "on_request": "Auf Anfrage",
    "only_x_left": "Nur noch {{ count }} verfügbar"
  },
  "discount_amount": "–{{value, currency(currency: EUR; minimumFractionDigits: 0; maximumFractionDigits: 0)}}",
  "discount_percentage": "–{{value}}%",
  "filter_results": "Ergebnisse filtern",
  "filter_tours": "Touren filtern",
  "format": {
    "date": "{{value, datetime(day: numeric; month: numeric; year: numeric)}}",
    "month": "{{value, datetime(month: long; year: numeric)}}",
    "price": "{{value, currency(currency: EUR; minimumFractionDigits: 0; maximumFractionDigits: 0)}}",
    "price_per_person": "{{value, currency(currency: EUR; minimumFractionDigits: 0; maximumFractionDigits: 0)}} p.P.",
    "weekday": "{{value, datetime(weekday: long)}}"
  },
  "fully_booked": {
    "after_one": "<0>{{count}} ausgebuchter Termin</0><1> gefunden nach </1><2>{{date, datetime(day: numeric; month: short; year: numeric)}}</2>",
    "after_other": "<0>{{count}} ausgebuchte Termine</0><1> gefunden nach </1><2>{{date, datetime(day: numeric; month: short; year: numeric)}}</2>",
    "before_one": "<0>{{count}} ausgebuchter Termin</0><1> gefunden vor </1><2>{{date, datetime(day: numeric; month: short; year: numeric)}}</2>",
    "before_other": "<0>{{count}} ausgebuchte Termine</0><1> gefunden vor </1><2>{{date, datetime(day: numeric; month: short; year: numeric)}}</2>",
    "between_one": "<0>{{count}} ausgebuchter Termin</0><1> gefunden zwischen </1><2>{{afterDate, datetime(day: numeric; month: short; year: numeric)}}</2><3> & </3><4>{{beforeDate, datetime(day: numeric; month: short; year: numeric)}}</4>",
    "between_other": "<0>{{count}} ausgebuchte Termine</0><1> gefunden zwischen </1><2>{{afterDate, datetime(day: numeric; month: short; year: numeric)}}</2><3> & </3><4>{{beforeDate, datetime(day: numeric; month: short; year: numeric)}}</4>",
    "only_one": "<0>{{count}} ausgebuchter Termin</0><1> gefunden</1>",
    "only_other": "<0>{{count}} ausgebuchte Termine</0><1> gefunden</1>"
  },
  "guaranteed": "Garantiert",
  "guidance": "Reiseleitung",
  "guidance_types": {
    "Guided": "Geführt",
    "Independent": "Individuell",
    "Semi-Guided": "Individuell mit Begleitung"
  },
  "load_more": "Mehr laden",
  "load_more_dates": "Weitere Termine laden",
  "maximum_occupancy_x_one": "Max {{ count }} Person",
  "maximum_occupancy_x_other": "Max {{ count }} Personen",
  "only_x_left": "Nur noch {{ count }} verfügbar",
  "persons": "Personen",
  "persons_in_cabins": "{{ persons }} in {{ cabins }}",
  "port_of_departure": "Abfahrtshafen",
  "prices_from": "Preis ab",
  "remove_cabin": "Kabine entfernen",
  "remove_x_cabins_one": "Kabine entfernen",
  "remove_x_cabins_other": "{{count}} Kabinen entfernen",
  "select_available_cabins": "Verfügbare Kabinen auswählen",
  "select_this_cabin": "Diese Kabine auswählen",
  "sgr": "{{count}}x {{ value, currency(currency: EUR; minimumFractionDigits: 0; maximumFractionDigits: 0) }} SGR - Insolvenzabsicherung",
  "ship": "Schiff",
  "show_x_tours_one": "{{ count }} Tour anzeigen",
  "show_x_tours_other": "{{ count }} Touren anzeigen",
  "single_use_notice": "Bei Einzelbelegung wird ein Einzelkabinenzuschlag berechnet.",
  "sort_by": "Sortieren nach",
  "sort_keys": {
    "price": "Preis",
    "start_date": "Startdatum"
  },
  "start_booking": "Buchung starten",
  "start_date": "Startdatum",
  "tooltips": {
    "guaranteed": {
      "description": "Diese Abfahrt findet garantiert statt, auch wenn die Mindestteilnehmerzahl nicht erreicht wird.",
      "title": "Was bedeutet „garantiert“?"
    },
    "on_request": {
      "description": "„Auf Anfrage“ bedeutet, dass wir die Verfügbarkeit aus verschiedenen Gründen noch prüfen müssen. Wir bestätigen Ihre Buchung oder schlagen Alternativen innerhalb von 48 Stunden vor.",
      "title": "Was bedeutet „auf Anfrage“?"
    }
  },
  "total_price": "Gesamtpreis",
  "view_cabin": "Details ansehen",
  "view_ship": "Schiff ansehen",
  "year": "Jahr",
  "x_cabins_one": "{{ count }} Kabine",
  "x_cabins_other": "{{ count }} Kabinen",
  "x_left": "{{ count }} verbleibend",
  "x_person_cabin": "{{ count }} Personen-Kabine",
  "x_persons_one": "{{ count }} Person",
  "x_persons_other": "{{ count }} Personen",
  "x_to_y_person_cabin": "{{ min }}-{{ max}} Personen-Kabine",
  "x_tours_one": "{{ count }} Tour",
  "x_tours_other": "{{ count }} Touren"
}
